/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../core/IceEntity';

export class accountingsummary extends IceEntity {
  key: string = "";
  current_ar_total: number = 0.0;
  current_revenue_total: number = 0.0;
  collected_total: number = 0.0;
  overdue_30_days: number = 0.0;
  overdue_60_days: number = 0.0;
  overdue_90_days: number = 0.0;
  overdue_120_days: number = 0.0;
  overdue_morethan150_days: number = 0.0;

  public gettablename(): string {
    return "ACCOUNTING_SUMMARY";
  }
}
